import type { HttpClient } from './http';
import type { RuntimeValue, RuntimeValueKind } from './types';

export interface RuntimeValuesApi {
  list(kind?: RuntimeValueKind): Promise<RuntimeValue[]>;
  save(runtimeValue: RuntimeValue): Promise<RuntimeValue>;
  reveal(id: string): Promise<RuntimeValue & { value: string }>;
  remove(id: string): Promise<void>;
}

export function createRuntimeValuesApi(http: HttpClient): RuntimeValuesApi {
  return {
    list: (kind?: RuntimeValueKind) =>
      http.get<RuntimeValue[]>(`/runtime-values${kind ? `?kind=${kind}` : ''}`),
    save: (runtimeValue: RuntimeValue) =>
      http.post<RuntimeValue>('/runtime-values', runtimeValue),
    reveal: (id: string) =>
      http.get<RuntimeValue & { value: string }>(
        `/runtime-values/${id}/reveal`
      ),
    remove: (id: string) => http.delete<void>(`/runtime-values/${id}`),
  };
}
